export const RouteNames = {
  OAUTH_CALLBACK: 'oauth-callback',
  SIGN_IN: 'sign-in',
  SIGN_UP: 'sign-up',
  PASSWORD_RESET: 'password-reset',
  SET_PASSWORD: 'set-password',
  DASHBOARD: 'dashboard',
  INVOICES: 'invoices',
  ENHANCEMENT_INVOICES: 'enhancement-invoices',
  INVOICE_DETAILS: 'invoice-details',
  GENERAL: 'general',
  MATTERS: 'matters',
  MATTER: 'matter',
  TIMEKEEPERS: 'timekeepers',
  LINE_ITEMS: 'line-items',
  FEE_ITEMS: 'fee-items',
  EXPENSE_ITEMS: 'expense-items',
  ACCOUNT: 'account',
  ACCOUNT_OVERVIEW: 'account-overview',
  ACCOUNT_SETTINGS: 'account-settings',
  ACCOUNT_BILLING: 'account-billing',
  ERROR_404: '404',
  ERROR_500: '500',
} as const;
